/**
 * A text input that auto-formats its value as Indonesian currency (Rp X.XXX.XXX)
 * as the user types. Internally stores and exposes raw digit strings.
 *
 * Props:
 *   id, value (raw digits string), onChange(rawDigits), label,
 *   placeholder, error, autoFocus, className
 */
const idrFormatter = new Intl.NumberFormat('id-ID', { maximumFractionDigits: 0 });

function formatCurrencyDisplay(rawDigits) {
  if (!rawDigits) return '';
  const num = parseInt(String(rawDigits).replace(/\D/g, ''), 10);
  return isNaN(num) ? '' : idrFormatter.format(num);
}

export default function CurrencyInput({
  id,
  value = '',
  onChange,
  label,
  placeholder = '0',
  error,
  autoFocus,
  className = '',
  ...rest
}) {
  const handleChange = (e) => {
    onChange?.(e.target.value.replace(/\D/g, ''));
  };

  return (
    <div className={`pa-currency-field${className ? ` ${className}` : ''}`}>
      {label && (
        <label className="lab-medium" htmlFor={id}>
          {label}
        </label>
      )}
      <div className="pa-currency-field__wrap">
        <span className="pa-currency-field__prefix" aria-hidden>
          Rp
        </span>
        <input
          id={id}
          type="text"
          inputMode="numeric"
          className={`pa-currency-field__input${error ? ' pa-currency-field__input--error' : ''}`}
          value={formatCurrencyDisplay(value)}
          onChange={handleChange}
          placeholder={idrFormatter.format(0).replace('0', placeholder)}
          autoFocus={autoFocus}
          {...rest}
        />
      </div>
      {error && <span className="pa-currency-field__error">{error}</span>}
    </div>
  );
}
